// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"1911":"6660bead4c3d0e31bf67","4158":"2a4b9c42f047c596e567"}[chunkId] + ".css";
};